module.exports = __webpack_public_path__ + "img/rocket-svgrepo-com.8ba9a6ee.svg";